import { render, staticRenderFns } from "./TopTabNew.vue?vue&type=template&id=0b3f9e06&scoped=true"
import script from "./TopTabNew.vue?vue&type=script&lang=js"
export * from "./TopTabNew.vue?vue&type=script&lang=js"
import style0 from "./TopTabNew.vue?vue&type=style&index=0&id=0b3f9e06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f9e06",
  null
  
)

export default component.exports